// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Envoyer',
    stop: 'Arrêter',
    attach: 'Joindre des fichiers',
    add: 'Ajouter',
    upload_files: 'Téléverser des fichiers',
  },
  attachment: {
    uploading: 'Téléversement {{percent}} %',
    uploading_file: 'Téléversement de {{name}}',
    retry: 'Réessayer',
    remove: 'Supprimer {{name}}',
    cancel: 'Annuler le téléversement de {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'En attente',
    running: 'En cours',
    done: 'Terminé',
    failed: 'Échec',
    denied: 'Refusé',
    background: 'Arrière-plan',
    summary_one: '{{count}} étape',
    summary_other: '{{count}} étapes',
    failed_count_one: '{{count}} échec',
    failed_count_other: '{{count}} échec',
    retried_one: '{{count}} échec a été relancé',
    retried_other: '{{count}} échecs ont été relancés',
  },
  question: {
    suggested: 'Suggéré',
    withdrawn: 'Plus nécessaire',
  },
  thread: {
    live_on: 'En ligne sur {{domain}}',
    unread_one: '{{count}} nouveaux',
    unread_other: '{{count}} nouveaux',
    working: 'En cours de traitement',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Terminé',
    running: 'En cours',
    waiting: 'Action requise',
    failed: 'Échec',
    pending: 'Pas encore',
    skipped: 'Ignoré',
  },
  lightbox: {
    enlarge: 'Agrandir : {{label}}',
    close: 'Fermer',
  },
};
